module.exports = __webpack_public_path__ + "img/title2.671c1823.png";